import React from 'react';
import PropTypes from 'prop-types';


export default class SliderItemTestimonials extends React.Component {
    static propTypes = {
        desc: PropTypes.object,
        author: PropTypes.object
    };

    static defaultProps = {
        desc: {},
        author: {}
    };


    render() {
        const {
            desc,
            author
        } = this.props;

        return (
            <div className="testimonial-block">
                <div className="desc">
                    <div className="text">{desc.text}</div>
                </div>
                <div className="author">
                    <div className="name">{author.name}</div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/modules/blocks/slider/sliderItemTestimonials.js